
import { useEffect, useRef, useState } from 'react'
import TimePicker from "rc-time-picker";
import { getNewGuid } from '../data/Help';



const TimeCtrl = ({ id, label, value, onChange, isRequired = true , placeholder}: ITimePicker) => {
    let inpuReqtRef = useRef<HTMLInputElement>(null);
    const [isValid, setIsvalid] = useState(false);

    useEffect(() => {
        if (isRequired) {
            inpuReqtRef.current?.setCustomValidity("");
            setIsvalid(true);
            if (value === undefined) {
                setIsvalid(false);
                inpuReqtRef.current?.setCustomValidity("Seleccione la hora");
            }
        }
    })

    return <>
        <div className="lbl-input-re-ni mt-10 mb-5">
            <span> {label} </span>
        </div>
        <div style={{display:'flex', justifyContent:'space-around'}}>
            <TimePicker
                id={id}
                name={id}
                showSecond={false}
                format={"hh:mm a"}
                onChange={onChange}
                use12Hours
                inputReadOnly
                className="time-re-ni"
                clearIcon={false}
                value={value}
                allowEmpty={false}
                popupClassName="time-popup-re-ni"
                placeholder={placeholder}
            />
            {isRequired && !isValid && (
                <input ref={inpuReqtRef} type="radio" name={getNewGuid()} className="sg-switch-validator mt-10" />
            )}
        </div>

    </>
}

export { TimeCtrl }